// src/i18n/es/views/iframes.js
export const iframes = {
  pricing: {
    title: "Calculadora de precios",
    description:
      "Configura precios base y unidades adicionales por plan; en la factura el impuesto aparece separado.",
    src: "https://player.vimeo.com/video/00000001",
    ariaLabel: "Vídeo: Calculadora de precios (ES)",
  },
  connectBooking: {
    title: "Conectar Booking.com",
    description:
      "Guía paso a paso para vincular tu propiedad con Booking.com mediante el Channel Manager.",
    src: "https://player.vimeo.com/video/00000002",
    ariaLabel: "Vídeo: Conexión con Booking.com (ES)",
  },
  connectAirbnb: {
    title: "Conectar Airbnb (vía Channex)",
    description:
      "Activa la conexión con Airbnb desde tu PMS usando Channex y sincroniza disponibilidad y tarifas.",
    src: "https://player.vimeo.com/video/00000003",
    ariaLabel: "Vídeo: Conexión con Airbnb (ES)",
  },
  channexCertification: {
    title: "Certificación Channex · PMS",
    description:
      "Requisitos y pruebas para completar la certificación PMS con Channex (full sync, precios y restricciones).",
    src: "https://player.vimeo.com/video/00000004",
    ariaLabel: "Vídeo: Certificación Channex (ES)",
  },
  hotelCalendar: {
    title: "Calendario de hotel (multihabitación)",
    description:
      "Gestiona reservas por tipo e instancia de habitación; evita overbookings con la vista estructurada.",
    src: "https://player.vimeo.com/video/00000005",
    ariaLabel: "Vídeo: Calendario de hotel (ES)",
  },
  apartmentCalendar: {
    title: "Calendario de apartamentos",
    description:
      "Bloqueos, precios por día y estancias en un calendario individual por propiedad.",
    src: "https://player.vimeo.com/video/00000006",
    ariaLabel: "Vídeo: Calendario de apartamentos (ES)",
  },
  guestCheckin: {
    title: "Check-in por WhatsApp",
    description:
      "El huésped escanea documento, verifica identidad y firma digitalmente desde su móvil.",
    src: "https://player.vimeo.com/video/00000007",
    ariaLabel: "Vídeo: Check-in por WhatsApp (ES)",
  },
  identityVerification: {
    title: "Verificación de identidad y firma",
    description:
      "Selfie-check, lectura MRZ/PDF417 y firma electrónica segura para cumplir normativa.",
    src: "https://player.vimeo.com/video/00000008",
    ariaLabel: "Vídeo: Verificación de identidad (ES)",
  },
  smartLocks: {
    title: "Cerraduras inteligentes",
    description:
      "Envía accesos automáticos sin llaves ni esperas; integra códigos dinámicos.",
    src: "https://player.vimeo.com/video/00000009",
    ariaLabel: "Vídeo: Cerraduras inteligentes (ES)",
  },
  reviewsAutomation: {
    title: "Automatización de reseñas",
    description:
      "Programa recordatorios de review y aumenta la reputación de tu alojamiento.",
    src: "https://player.vimeo.com/video/00000010",
    ariaLabel: "Vídeo: Automatización de reseñas (ES)",
  },
};
